import styled from "styled-components";
import { Card } from "antd";

export const FormSectionCard = styled(Card)`
  &.ant-card {
    > .ant-card-head,
    > .ant-card-body {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
